/**
 * Text truncation and display limits used throughout the application
 */

// Default truncation settings
export const DEFAULT_TRUNCATE_LENGTH = 100;
export const TRUNCATE_SUFFIX = " ... ";

// First prompt display limit
export const FIRST_PROMPT_MAX_LENGTH = 100;

// Search result preview lengths
export const USER_MESSAGE_START_LENGTH = 65;
export const USER_MESSAGE_PREVIEW_LENGTH = 65;
export const USER_MESSAGE_LENGTH = 130;
export const RESPONSE_PREVIEW_LENGTH = 350;
